import React, { useEffect, useState } from "react";
import WinePlatterVideoOverlay from "../Home/WinePlatterVideoOverlay";

const DECOR_ICONS = {
  topRight: "/top-droite.svg",
};

const AGE_GATE_STORAGE_KEY = "md_age_gate_alcool_18_plus";

function DecoImg({ src, className }) {
  if (!src) return null;
  return <img src={src} alt="" aria-hidden="true" className={className} />;
}

export default function AlcoolView({
  t = {},
  setVueActuelle,
  children,
  categorieActive = null,
  onBackCategories = null,
}) {
  const showBackLink =
    !!categorieActive && typeof onBackCategories === "function";

  const [ageGateResolved, setAgeGateResolved] = useState(false);
  const [showAgeGate, setShowAgeGate] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(AGE_GATE_STORAGE_KEY);
      const accepted = saved === "accepted";

      if (accepted) {
        setAgeGateResolved(true);
        setShowAgeGate(false);
        return;
      }

      setAgeGateResolved(false);
      setShowAgeGate(true);
    } catch (e) {
      setAgeGateResolved(false);
      setShowAgeGate(true);
    }
  }, []);

  const handleAccept18 = () => {
    try {
      localStorage.setItem(AGE_GATE_STORAGE_KEY, "accepted");
    } catch (e) {}

    setAgeGateResolved(true);
    setShowAgeGate(false);
  };

  const handleDecline18 = () => {
    try {
      localStorage.removeItem(AGE_GATE_STORAGE_KEY);
    } catch (e) {}

    setAgeGateResolved(false);
    setShowAgeGate(false);
    setVueActuelle?.("accueil");
  };

  const ageGateTitle = t?.alcoolAgeGateTitle || "Avez-vous 18 ans ou plus ?";
  const ageGateText =
    t?.alcoolAgeGateText ||
    "L’accès à cet univers est réservé aux personnes majeures. Veuillez confirmer que vous avez au moins 18 ans.";
  const ageGateAccept = t?.alcoolAgeGateAccept || "J’ai 18 ans ou plus";
  const ageGateDecline = t?.alcoolAgeGateDecline || "Je n’ai pas 18 ans";

  const canRenderAlcoholContent = ageGateResolved;

  return (
    <section className="alcool-view">
      <div className="alcool-bg" aria-hidden="true" />
      <div className="alcool-shell">
        <div className="alcool-hero">
          <div className="alcool-hero-overlay" />

          <div className="alcool-hero-top-row">
            <div className="alcool-hero-top-right">
              <DecoImg
                src={DECOR_ICONS.topRight}
                className="alcool-deco alcool-deco-top-right"
              />
            </div>
          </div>

          <div className="alcool-hero-content">
            <h1 className="alcool-title">
              {t?.alcoolHeroTitle ||
                "NOUS VOUS PROPOSONS EXACTEMENT CE QUE VOUS CHERCHEZ"}
            </h1>
          </div>
        </div>

        <div className="alcool-video-top-card">
          <div className="alcool-video-top-head">
            <span className="alcool-kicker">
              {t?.alcoolSelectionKicker || "Sélection en scène"}
            </span>
            <span className="alcool-line" />
          </div>

          <div className="alcool-video-stage">
            <div className="alcool-video-glow" />
            <WinePlatterVideoOverlay />
          </div>
        </div>

        {canRenderAlcoholContent && showBackLink ? (
          <div className="alcool-back-row">
            <button
              type="button"
              className="alcool-back-link"
              onClick={onBackCategories}
            >
              <span className="alcool-back-arrow">←</span>
              <span>{t?.allProducts || "Tous les produits"}</span>
            </button>
          </div>
        ) : null}

        {canRenderAlcoholContent && children ? (
          <div className="alcool-dynamic-content">{children}</div>
        ) : null}

        <div className="alcool-cta-row alcool-cta-bottom">
          <div className="alcool-btn-wrap">
            <button
              type="button"
              className="alcool-btn alcool-btn-primary"
              onClick={() => setVueActuelle("magasin")}
            >
              {t?.alcoolDiscoverShop || "Découvrir le magasin"}
            </button>
          </div>

          <div className="alcool-btn-wrap">
            <button
              type="button"
              className="alcool-btn alcool-btn-secondary"
              onClick={() => setVueActuelle("plateaux-evenements")}
            >
              {t?.plateauxNav || t?.plateauxButton || "Nos plateaux"}
            </button>
          </div>

          <div className="alcool-btn-wrap">
            <button
              type="button"
              className="alcool-btn alcool-btn-secondary"
              onClick={() => setVueActuelle("service")}
            >
              {t?.services || "Nos services"}
            </button>
          </div>
        </div>
      </div>

      {showAgeGate ? (
        <div className="alcool-agegate-overlay" role="dialog" aria-modal="true">
          <div className="alcool-agegate-card">
            <div className="alcool-agegate-kicker">
              {t?.alcoolAgeGateKicker || "Accès réglementé"}
            </div>

            <h2 className="alcool-agegate-title">{ageGateTitle}</h2>

            <p className="alcool-agegate-text">{ageGateText}</p>

            <div className="alcool-agegate-actions">
              <button
                type="button"
                className="alcool-agegate-btn alcool-agegate-btn-primary"
                onClick={handleAccept18}
              >
                {ageGateAccept}
              </button>

              <button
                type="button"
                className="alcool-agegate-btn alcool-agegate-btn-secondary"
                onClick={handleDecline18}
              >
                {ageGateDecline}
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <style jsx="true">{`
  .alcool-view {
    width: 100%;
    min-height: 100vh;
    padding: 12px 0 160px;
    position: relative;
    overflow: visible;
    background: transparent;
    isolation: isolate;
  }

  .alcool-bg {
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background-image: url("https://app.marchedeluxe.ch/images/ArrierePlanAlcoolEntry.png");
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }

  :global(body:has(.alcool-view) .main-nav),
  :global(body:has(.alcool-view) header) {
    background: transparent !important;
    background-color: transparent !important;
    box-shadow: none !important;
    border: none !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
  }

  :global(body:has(.alcool-view) .main-nav::before),
  :global(body:has(.alcool-view) .main-nav::after),
  :global(body:has(.alcool-view) header::before),
  :global(body:has(.alcool-view) header::after) {
    display: none !important;
    background: transparent !important;
  }

  :global(#root),
  :global(#__next),
  :global(.App),
  :global(.app),
  :global(main) {
    background: transparent !important;
  }

  :global(.main-nav),
  :global(.navbar),
  :global(.navigation),
  :global(header) {
    background: transparent !important;
    background-color: transparent !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    box-shadow: none !important;
    border: none !important;
  }

  .alcool-shell {
    width: min(100%, 1180px);
    margin: 0 auto;
    padding: 0 16px;
    position: relative;
    z-index: 2;
  }

  .alcool-hero {
    position: relative;
    overflow: hidden;
    border-radius: 28px;
    min-height: 220px;
    background: rgba(246, 237, 226, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 18px 45px rgba(22, 14, 8, 0.06);
    margin-bottom: 18px;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
  }

  .alcool-hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 245, 230, 0.12) 0%,
      rgba(255, 245, 230, 0.05) 48%,
      rgba(255, 245, 230, 0.01) 100%
    );
    pointer-events: none;
  }

  .alcool-hero-top-row {
    position: relative;
    z-index: 2;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 16px 18px 0;
    min-height: 74px;
    box-sizing: border-box;
  }

  .alcool-hero-top-right {
   display: flex; 
   align-items: 
   flex-start; 
   justify-content: flex-end; }

  .alcool-hero-content {
    position: relative;
    z-index: 2;
    padding: 0 24px 28px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }

  .alcool-title {
    margin: 0;
    width: 100%;
    color: #241915;
    font-family: "Playfair Display", serif;
    font-weight: 400;
    font-size: clamp(2rem, 6vw, 4rem);
    line-height: 1.02;
    letter-spacing: 0.01em;
    text-shadow: 0 1px 0 rgba(255, 245, 232, 0.42);
  }

  .alcool-cta-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    max-width: 820px;
  }

  .alcool-cta-bottom {
    margin: 36px auto 0;
  }

  .alcool-btn-wrap {
    position: relative;
    flex: 1 1 180px;
    min-width: 0;
    display: flex;
  }

  .alcool-btn {
    appearance: none;
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 14px;
    min-height: 48px;
    padding: 0 18px;
    cursor: pointer;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 700;
    flex: 1;
    color: #241915;
    background: rgba(255, 248, 238, 0.26);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    box-shadow: 0 8px 22px rgba(22, 14, 8, 0.04);
  }

  .alcool-btn:hover {
    transform: translateY(-1px);
  }

  .alcool-btn-primary {
    background: rgba(242, 229, 210, 0.34);
  }

  .alcool-btn-secondary {
    background: rgba(255, 255, 255, 0.18);
  }

  .alcool-video-top-card {
    position: relative;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(246, 237, 226, 0.14);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    box-shadow: 0 10px 24px rgba(60, 42, 22, 0.025);
    padding: 18px 16px 20px;
    margin: -12px 0 18px;
    overflow: visible;
  }

  .alcool-video-top-head {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  .alcool-video-stage {
    position: relative;
    width: 100%;
    min-height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 22px;
    overflow: visible;
    background: rgba(255, 255, 255, 0.08);
    padding: 10px 0;
  }

  .alcool-video-glow {
    position: absolute;
    width: 72%;
    height: 72%;
    border-radius: 999px;
    background: radial-gradient(
      circle,
      rgba(118, 20, 39, 0.08) 0%,
      rgba(118, 20, 39, 0.03) 34%,
      rgba(118, 20, 39, 0) 72%
    );
    filter: blur(18px);
    pointer-events: none;
    z-index: 0;
  }

  .alcool-back-row {
    width: 100%;
    margin: 2px 0 10px;
    padding: 0 2px;
  }

  .alcool-back-link {
    appearance: none;
    border: none;
    background: transparent;
    padding: 6px 4px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    color: #241915;
    font-family: "Playfair Display", serif;
    font-size: clamp(1.05rem, 2vw, 1.35rem);
    letter-spacing: 0.12em;
    text-transform: uppercase;
    text-shadow: 0 1px 0 rgba(255, 245, 232, 0.42);
  }

  .alcool-back-arrow {
    font-family: "Inter", sans-serif;
    font-size: 1rem;
    letter-spacing: 0;
    transform: translateY(-1px);
  }

  .alcool-dynamic-content {
    margin-top: 10px;
    position: relative;
    z-index: 2;
  }

  :global(.alcool-view .categorie-card),
  :global(.alcool-view .category-card),
  :global(.alcool-view .product-category-card),
  :global(.alcool-view .alcool-category-card),
  :global(.alcool-view .famille-card),
  :global(.alcool-view .card),
  :global(.alcool-view .selection-card) {
    background: rgba(255, 248, 238, 0.12) !important;
    border-color: rgba(255, 255, 255, 0.16) !important;
    box-shadow: 0 8px 20px rgba(22, 14, 8, 0.03) !important;
    backdrop-filter: blur(1.5px) !important;
    -webkit-backdrop-filter: blur(1.5px) !important;
  }

  :global(.alcool-view .categorie-card:hover),
  :global(.alcool-view .category-card:hover),
  :global(.alcool-view .product-category-card:hover),
  :global(.alcool-view .alcool-category-card:hover),
  :global(.alcool-view .famille-card:hover),
  :global(.alcool-view .card:hover),
  :global(.alcool-view .selection-card:hover) {
    background: rgba(255, 248, 238, 0.2) !important;
  }

  .alcool-deco {
    z-index: 1;
    pointer-events: none;
    user-select: none;
    object-fit: contain;
    display: block;
    height: auto;
    opacity: 1;
    max-width: 100%;
  }

  .alcool-deco-top-right {
  width: clamp(210px, 16vw, 220px);
}

  .alcool-kicker {
    white-space: nowrap;
    color: #b8964e;
    font-family: "Inter", sans-serif;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .alcool-line {
    display: block;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      90deg,
      rgba(184, 150, 78, 0.32) 0%,
      rgba(184, 150, 78, 0.02) 100%
    );
  }

  .alcool-agegate-overlay {
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px;
    background: rgba(16, 12, 9, 0.7);
    backdrop-filter: blur(8px);
  }

  .alcool-agegate-card {
    width: min(100%, 520px);
    border-radius: 24px;
    padding: 26px 22px 22px;
    background: rgba(249, 244, 236, 0.92);
    border: 1px solid rgba(84, 61, 33, 0.1);
    box-shadow: 0 26px 60px rgba(0, 0, 0, 0.22);
    text-align: center;
  }

  .alcool-agegate-kicker {
    margin-bottom: 10px;
    color: #876742;
    font-family: "Inter", sans-serif;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .alcool-agegate-title {
    margin: 0;
    color: #2d2117;
    font-family: "Playfair Display", serif;
    font-size: clamp(1.6rem, 4vw, 2.2rem);
    line-height: 1.08;
    font-weight: 500;
  }

  .alcool-agegate-text {
    margin: 14px 0 0;
    color: #4d3b2c;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    line-height: 1.65;
  }

  .alcool-agegate-actions {
    margin-top: 22px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .alcool-agegate-btn {
    appearance: none;
    border-radius: 14px;
    min-height: 48px;
    padding: 0 16px;
    cursor: pointer;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 700;
  }

  .alcool-agegate-btn-primary {
    border: none;
    background: #f2e5d2;
    color: #2d2117;
  }

  .alcool-agegate-btn-secondary {
    background: rgba(125, 94, 55, 0.05);
    color: #3a2a1d;
    border: 1px solid rgba(125, 94, 55, 0.14);
  }

  @media (max-width: 920px) {
    .alcool-video-stage {
      min-height: 240px;
    }

    .alcool-hero-top-row {
      min-height: 102px;
    }

    .alcool-hero-content {
      padding: 0 20px 24px;
    }

    .alcool-title {
      font-size: clamp(1.9rem, 5.8vw, 3.1rem);
      line-height: 1.03;
    }
  }

  @media (max-width: 640px) {
    .alcool-view {
      padding: 8px 0 120px;
    }

    .alcool-shell {
      width: 100%;
      max-width: 100%;
      padding: 0 8px;
    }

    .alcool-hero {
      border-radius: 22px;
      min-height: auto;
      background: rgba(246, 237, 226, 0.14);
    }

    .alcool-hero-top-row {
      padding: 10px 10px 0;
      min-height: 46px;
    }

    .alcool-hero-content {
      padding: 0 14px 18px;
    }

    .alcool-title {
      font-size: clamp(1.55rem, 8.2vw, 2.3rem);
      line-height: 1.04;
      letter-spacing: 0;
    }

    .alcool-cta-row {
      gap: 10px;
      max-width: 100%;
    }

    .alcool-btn-wrap {
      flex: 1 1 calc(50% - 5px);
    }

    .alcool-btn {
      min-height: 46px;
      padding: 0 12px;
      font-size: 13px;
    }

    .alcool-video-top-card {
      border-radius: 18px;
      background: rgba(246, 237, 226, 0.12);
    }

    .alcool-video-stage {
      min-height: 180px;
      border-radius: 18px;
      padding: 6px 0;
      background: rgba(255, 255, 255, 0.06);
    }

    .alcool-back-row {
      margin: 0 0 8px;
      padding: 0 4px;
    }

    .alcool-back-link {
      gap: 8px;
      padding: 6px 2px;
      font-size: 1rem;
      letter-spacing: 0.09em;
    }

    .alcool-agegate-card {
      border-radius: 18px;
      padding: 22px 16px 16px;
    }

    .alcool-agegate-text {
      font-size: 14px;
      line-height: 1.6;
    }

    .alcool-agegate-btn {
      min-height: 46px;
      font-size: 13px;
    }

    .alcool-hero-top-right {
  width: clamp(190px, 34vw, 185px);
}

.alcool-deco-top-right {
  width: clamp(190px, 34vw, 185px);
}
  }
`}</style>
    </section>
  );
}